<template>
  <div class="step-qna upload-assets-section">
    <section>
      <div class="d-flex justify-content-center">
        <h4>Please upload exterior photos of the property:</h4>
      </div>
      <b-row class="d-flex justify-content-center">
        <b-form-group
          id="fieldset-1"
          label="Front (from street) and Back (from each corner towards house)"
          label-for="exterior-upload"
        >
          <b-form-file
            id="exterior-upload"
            multiple
            v-model="exteriorFiles"
            accept="image/jpeg, image/png"
            placeholder="Choose files or drop them here..."
            drop-placeholder="Drop file here..."
          >
          </b-form-file>
        </b-form-group>
      </b-row>
      <b-row class="d-flex justify-content-center">
        Uploaded Files: 
        <ul>
          <li
            v-for="file in exteriorAttachments"
            :key="file.name"
          >
            {{file.name}}
          </li>
        </ul>
      </b-row>
      <b-row class="d-flex justify-content-center h-buttons">
        <b-button
          class="button"
          pill
          variant="outline-secondary"
          :disabled="uploadingExterior"
          @click="exteriorFiles = []"
        >
          Clear
        </b-button>
        <b-button
          class="button"
          pill
          variant="outline-secondary"
          :disabled="uploadingExterior"
          @click="uploadExteriorFiles"
        >
          Upload
        </b-button>
      </b-row>
    </section>
    <section>
      <div class="d-flex justify-content-center">
        <h4>Please upload interior photos of the property:</h4>
      </div>
      <b-row class="d-flex justify-content-center">
        <b-form-group
          id="fieldset-1"
          label="Living Room, Kitchen, Appliances (Oven, Cooktop, Dishwasher, Refrigerator), Dining Room, Master Bedroom, Master Bathroom, Guest Rooms, Guest Bathrooms"
          label-for="interior-upload"
        >
          <b-form-file
            id="interior-upload"
            multiple
            v-model="interiorFiles"
            accept="image/jpeg, image/png"
            placeholder="Choose files or drop them here..."
            drop-placeholder="Drop file here..."
          >
          </b-form-file>
        </b-form-group>
      </b-row>
      <b-row class="d-flex justify-content-center">
        Uploaded Files: 
        <ul>
          <li
            v-for="file in interiorAttachments"
            :key="file.name"
          >
            {{file.name}}
          </li>
        </ul>
      </b-row>
      <b-row class="d-flex justify-content-center h-buttons">
        <b-button
          class="button"
          pill
          variant="outline-secondary"
          :disabled="uploadingInterior"
          @click="interiorFiles = []"
        >
          Clear
        </b-button>
        <b-button
          class="button"
          pill
          variant="outline-secondary"
          :disabled="uploadingInterior"
          @click="uploadInteriorFiles"
        >
          Upload
        </b-button>
      </b-row>
    </section>
    <section>
      <div class="d-flex justify-content-center">
        <h4>Please upload other photos of the property if any that would affect the property value:</h4>
      </div>
      <b-row class="d-flex justify-content-center">
        <b-form-group
          id="fieldset-1"
          label-for="other-upload"
        >
          <b-form-file
            id="other-upload"
            multiple
            v-model="otherFiles"
            accept="image/jpeg, image/png"
            placeholder="Choose files or drop them here..."
            drop-placeholder="Drop file here..."
          >
          </b-form-file>
        </b-form-group>
      </b-row>
      <b-row class="d-flex justify-content-center">
        Uploaded Files: 
        <ul>
          <li
            v-for="file in otherAttachments"
            :key="file.name"
          >
            {{file.name}}
          </li>
        </ul>
      </b-row>
      <b-row class="d-flex justify-content-center h-buttons">
        <b-button
          class="button"
          pill
          variant="outline-secondary"
          :disabled="uploadingOther"
          @click="otherFiles = []"
        >
          Clear
        </b-button>
        <b-button
          class="button"
          pill
          variant="outline-secondary"
          :disabled="uploadingOther"
          @click="uploadOtherFiles"
        >
          Upload
        </b-button>
      </b-row>
    </section>
    <section>
      <div class="d-flex justify-content-center">
        <h4>Please upload video(s) of the property:</h4>
      </div>
      <b-row class="d-flex justify-content-center">
        <b-form-group
          id="fieldset-1"
          label-for="video-upload"
        >
          <b-form-file
            id="video-upload"
            multiple
            v-model="videoFiles"
            accept=".mp4, .mov"
            placeholder="Choose files or drop them here..."
            drop-placeholder="Drop file here..."
          >
          </b-form-file>
        </b-form-group>
      </b-row>
      <b-row class="d-flex justify-content-center">
        Uploaded Files: 
        <ul>
          <li
            v-for="file in videoAttachments"
            :key="file.name"
          >
            {{file.name}}
          </li>
        </ul>
      </b-row>
      <b-row class="d-flex justify-content-center h-buttons">
        <b-button
          class="button"
          pill
          variant="outline-secondary"
          :disabled="uploadingVideo"
          @click="videoFiles = []"
        >
          Clear
        </b-button>
        <b-button
          class="button"
          pill
          variant="outline-secondary"
          :disabled="uploadingVideo"
          @click="uploadVideoFiles"
        >
          Upload
        </b-button>
      </b-row>
    </section>
  </div>
</template>
<script>
import { uploadFile } from "@/services/apiService";

export default {
  name: "UploadAssets",
  data: () => {
    return {
      fileAttachments: [],
      exteriorFiles: [],
      exteriorAttachments: [],
      uploadingExterior: false,
      interiorFiles: [],
      interiorAttachments: [],
      uploadingInterior: false,
      otherFiles: [],
      otherAttachments: [],
      uploadingOther: false,
      videoFiles: [],
      videoAttachments: [],
      uploadingVideo: false,
    };
  },
  methods: {
    uploadFiles: async function(files, type) {
      const uploadedFiles = await Promise.all(
        files.map((file) => uploadFile(file))
      );
      const attachments = uploadedFiles.map((file) => this.createAttachment(file, type));
      this.fileAttachments.push(
        ...attachments
      );
      this.$emit("on-upload", this.fileAttachments);
      return attachments;
    },
    createAttachment: function(file, type) {
      return {
        name: file.fileName,
        storageName: file.storageName,
        bucket: "idealagent-cash-offer-client-files",
        type: type,
      };
    },
    uploadExteriorFiles: async function() {
      this.uploadingExterior = true;
      const attachments = await this.uploadFiles(this.exteriorFiles, "OFFER_PROPERTY_EXT_PHOTOS");
      this.exteriorAttachments.push(...attachments);
      this.uploadingExterior = false;
    },
    uploadInteriorFiles: async function() {
      this.uploadingInterior = true;
      const attachments = await this.uploadFiles(this.interiorFiles, "OFFER_PROPERTY_INT_PHOTOS");
      this.interiorAttachments.push(...attachments);
      this.uploadingInterior = false
    },
    uploadOtherFiles: async function() {
      this.uploadingOther = true;
      const attachments = await this.uploadFiles(this.otherFiles, "OFFER_PROPERTY_OTHER_PHOTOS");
      this.otherAttachments.push(...attachments);
      this.uploadingOther = false
    },
    uploadVideoFiles: async function() {
      this.uploadingVideo = true;
      const attachments = await this.uploadFiles(this.videoFiles, "OFFER_PROPERTY_VIDEO");
      this.videoAttachments.push(...attachments);
      this.uploadingVideo = false
    },
  },
};
</script>
